import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { url: String, title: String, text: String }

  connect() {
    if (navigator.share) {
      this.element.removeAttribute("hidden")
    }
  }

  share(event) {
    if (navigator.share) {
      event.stopImmediatePropagation()
      navigator.share({
        title: this.titleValue,
        text: this.textValue,
        url: this.urlValue
      }).catch(() => {
        // User cancelled share — do nothing
      })
    }
    // If navigator.share not available, event propagates to clipboard#copy fallback
  }
}
